import { handleActions } from 'redux-actions';
import * as Actions from '../actions/schoolEntryActions';

const app = handleActions({
  [Actions.setSchoolNames]: (state, action) => ({
    ...state,
    schoolNames: action.payload,
  }),
  [Actions.setLoadingSchoolNames]: (state, action) => ({
    ...state,
    loadingSchoolNames: action.payload,
  }),
  [Actions.setCourses]: (state, action) => ({
    ...state,
    courses: action.payload,
  }),
  [Actions.setDayLocations]: (state, action) => ({
    ...state,
    dayLocations: action.payload,
  }),
  [Actions.setPrices]: (state, action) => ({
    ...state,
    prices: action.payload,
  }),
  [Actions.setPcTypes]: (state, action) => ({
    ...state,
    pcTypes: action.payload,
  }),
  [Actions.setOpenPopover]: (state, action) => ({
    ...state,
    popoverOpen: action.payload,
  }),
  [Actions.setIsFreeTrial]: (state, action) => ({
    ...state,
    isFreeTrial: action.payload,
  }),
  [Actions.toggleModal]: (state) => ({
    ...state,
    modal: !state.modal,
  }),
  [Actions.setPcSucceed]: (state) => ({
    ...state,
    setPcSucceed: true,
  }),
  [Actions.setInnovationStudioSelected]: (state, action) => ({
    ...state,
    innovationStudioSelected: action.payload,
  }),
  [Actions.setContinued]: (state, action) => ({
    ...state,
    continued: action.payload,
  }),
}, {
  schoolNames: [],
  loadingSchoolNames: false,
  courses: [],
  dayLocations: [],
  prices: {},
  pcTypes: [],
  popoverOpen: false,
  isFreeTrial: false,
  modal: false,
  setPcSucceed: false,
  innovationStudioSelected: false,
  continued: false,
});

export default app;
